<template>
  <div class="applied-amenities p-t-20 p-b-20 m-t-20 m-b-20">
    <div class="applied-amenities__header m-b-20">
      <h2 class="p-b-20">Payment</h2>
    </div>
    <div class="applied-amenities__container">
      <div v-for="amenity in amenitiesObj.amenities" :key="amenity.card" class="applied-amenities__item m-b-10">
        <p>
          {{ amenity.selectedTender.buttonText || amenity.selectedTender.name }} {{ maskedCredential(amenity.card) }}
          {{ amenity.selectedTender.selectionName ? ` - ${amenity.selectedTender.selectionName}` : "" }}
        </p>
        <p class="applied-amenities__item__applied-balance">-{{ prependUsdSign(amenity.appliedAmenity) }}</p>
        <div>
          <label :for="amenity.id" class="iw-visuallyhidden">remove amenity</label>
          <button :id="amenity.id" class="applied-amenities__remove-amenity" @click="removeAmenity($event, amenity)"></button>
        </div>
      </div>
    </div>
    <div class="applied-amenities__balance m-b-20">
      <p>Balance Due</p>
      <p>{{ prependUsdSign(balanceDue()) }}</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { prependUsdSign, maskedCredential } from "@/utils";

export default {
  name: "AppliedAmenities",
  computed: {
    ...mapGetters({
      amenitiesObj: "cart/getAmenitiesWithCardBalanceInUse"
    })
  },
  methods: {
    ...mapActions({
      removePPIAmenity: "cart/removePPIAmenity"
    }),
    balanceDue() {
      return this.amenitiesObj.balance;
    },
    prependUsdSign,
    maskedCredential,
    async removeAmenity(event, amenity) {
      if (amenity && amenity.id) {
        await this.removePPIAmenity({ id: amenity.id });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.applied-amenities {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 1em;

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @include respond-to-mobile {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0px 0.2em;
    }
  }

  &__header {
    border-bottom: none;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background-color: $applied-amenity-background;
    border-radius: 10px;
    padding: 0 1.2em 0 1.2em;

    @include respond-to-mobile {
      padding: 0 1em 0 1em;
      margin-left: -5px;
    }

    &__applied-balance {
      color: $applied-amenity-color;
      margin-left: auto;
      margin-right: 15px;
    }
  }

  &__balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-top: 1px solid $applied-amenity-border;

    & > p {
      font-size: 1.2em;
    }
  }

  &__remove-amenity {
    position: relative;
    width: 32px;
    height: 32px;
    cursor: pointer;

    &:before,
    &:after {
      position: absolute;
      top: 8px;
      left: 15px;
      content: "";
      height: 15px;
      width: 3px;
      background-color: $text-color;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }

    border: 0;
    border-radius: 16px;
    @include respond-to-mobile {
      margin: 4px 2px 0 0;
    }
  }

  @include respond-to-mobile {
    width: 100%;
    margin-left: 0;
  }
}
</style>
